var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "b-container",
    { staticClass: "admin-orders", attrs: { fluid: "" } },
    [
      _c("admin-preloader", { attrs: { show: _vm.loading } }),
      _vm._v(" "),
      _c("admin-breadcrumb", { attrs: { name: "Orders" } }),
      _vm._v(" "),
      _c(
        "b-row",
        [
          _c(
            "b-col",
            { attrs: { cols: "12" } },
            [
              _c(
                "admin-panel",
                {
                  attrs: { title: "Orders", "with-footer": "" },
                  scopedSlots: _vm._u([
                    {
                      key: "header-right",
                      fn: function () {
                        return [
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-n2 d-flex flex-wrap admin-order-filters",
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "mt-1 mr-2" },
                                [
                                  _c("div", [_vm._v("Order #")]),
                                  _vm._v(" "),
                                  _c("b-input", {
                                    staticClass: "mt-1 orders-filter-input",
                                    staticStyle: { width: "100px" },
                                    attrs: {
                                      type: "number",
                                      "no-wheel": "",
                                      autocomplete: "off",
                                    },
                                    on: {
                                      input: (value) =>
                                        _vm.inputFilterChanged("number", value),
                                    },
                                    model: {
                                      value: _vm.filters.number,
                                      callback: function ($$v) {
                                        _vm.$set(
                                          _vm.filters,
                                          "number",
                                          typeof $$v === "string"
                                            ? $$v.trim()
                                            : $$v
                                        )
                                      },
                                      expression: "filters.number",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1 mr-2" }, [
                                _c("div", [_vm._v("Seller")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { width: "200px" } },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass:
                                          "mt-1 orders-filter-dropdown",
                                        attrs: {
                                          variant: "outline-secondary",
                                          text: _vm.sellersFilterLabel,
                                          block: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "max-height": "60vh",
                                              "overflow-y": "auto",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-dropdown-item-button",
                                              {
                                                attrs: {
                                                  active:
                                                    _vm.filters.sellers.indexOf(
                                                      ""
                                                    ) >= 0,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleFilterValue(
                                                      "sellers",
                                                      ""
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      All\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.licensesByCompanies,
                                              function (company, key) {
                                                return _c(
                                                  "div",
                                                  { key: key },
                                                  [
                                                    _c("b-dropdown-divider"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-dropdown-group",
                                                      {
                                                        attrs: {
                                                          header:
                                                            company.company_name,
                                                        },
                                                      },
                                                      _vm._l(
                                                        company.licenses,
                                                        function (option, key) {
                                                          return _c(
                                                            "b-dropdown-item-button",
                                                            {
                                                              key: key,
                                                              attrs: {
                                                                active:
                                                                  _vm.filters.sellers.indexOf(
                                                                    option.value
                                                                  ) >= 0,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleFilterValue(
                                                                      "sellers",
                                                                      option.value
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              option.value !==
                                                                "" &&
                                                              _vm.filters.sellers.indexOf(
                                                                option.value
                                                              ) >= 0
                                                                ? _c(
                                                                    "b-icon-check"
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    option.text
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1 mr-2" }, [
                                _c("div", [_vm._v("Buyer")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { width: "200px" } },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass:
                                          "mt-1 orders-filter-dropdown",
                                        attrs: {
                                          variant: "outline-secondary",
                                          text: _vm.buyersFilterLabel,
                                          block: "",
                                        },
                                      },
                                      [
                                        _c(
                                          "div",
                                          {
                                            staticStyle: {
                                              "max-height": "60vh",
                                              "overflow-y": "auto",
                                            },
                                          },
                                          [
                                            _c(
                                              "b-dropdown-item-button",
                                              {
                                                attrs: {
                                                  active:
                                                    _vm.filters.buyers.indexOf(
                                                      ""
                                                    ) >= 0,
                                                },
                                                on: {
                                                  click: function ($event) {
                                                    return _vm.toggleFilterValue(
                                                      "buyers",
                                                      ""
                                                    )
                                                  },
                                                },
                                              },
                                              [
                                                _vm._v(
                                                  "\n                      All\n                    "
                                                ),
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _vm._l(
                                              _vm.licensesByCompanies,
                                              function (company, key) {
                                                return _c(
                                                  "div",
                                                  { key: key },
                                                  [
                                                    _c("b-dropdown-divider"),
                                                    _vm._v(" "),
                                                    _c(
                                                      "b-dropdown-group",
                                                      {
                                                        attrs: {
                                                          header:
                                                            company.company_name,
                                                        },
                                                      },
                                                      _vm._l(
                                                        company.licenses,
                                                        function (option, key) {
                                                          return _c(
                                                            "b-dropdown-item-button",
                                                            {
                                                              key: key,
                                                              attrs: {
                                                                active:
                                                                  _vm.filters.buyers.indexOf(
                                                                    option.value
                                                                  ) >= 0,
                                                              },
                                                              on: {
                                                                click:
                                                                  function (
                                                                    $event
                                                                  ) {
                                                                    return _vm.toggleFilterValue(
                                                                      "buyers",
                                                                      option.value
                                                                    )
                                                                  },
                                                              },
                                                            },
                                                            [
                                                              option.value !==
                                                                "" &&
                                                              _vm.filters.buyers.indexOf(
                                                                option.value
                                                              ) >= 0
                                                                ? _c(
                                                                    "b-icon-check"
                                                                  )
                                                                : _vm._e(),
                                                              _vm._v(
                                                                "\n                          " +
                                                                  _vm._s(
                                                                    option.text
                                                                  ) +
                                                                  "\n                        "
                                                              ),
                                                            ],
                                                            1
                                                          )
                                                        }
                                                      ),
                                                      1
                                                    ),
                                                  ],
                                                  1
                                                )
                                              }
                                            ),
                                          ],
                                          2
                                        ),
                                      ]
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1 mr-2" }, [
                                _c("div", [_vm._v("Source")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { width: "120px" } },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass:
                                          "mt-1 orders-filter-dropdown",
                                        attrs: {
                                          variant: "outline-secondary",
                                          text: _vm.sourcesFilterLabel,
                                          block: "",
                                        },
                                      },
                                      _vm._l(
                                        _vm.orderSourcesOptions,
                                        function (option, key) {
                                          return _c(
                                            "b-dropdown-item-button",
                                            {
                                              key: key,
                                              attrs: {
                                                active:
                                                  _vm.filters.sources.indexOf(
                                                    option.value
                                                  ) >= 0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleFilterValue(
                                                    "sources",
                                                    option.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              option.value !== "" &&
                                              _vm.filters.sources.indexOf(
                                                option.value
                                              ) >= 0
                                                ? _c("b-icon-check")
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(option.text) +
                                                  "\n                  "
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1 mr-2" }, [
                                _c("div", [_vm._v("Type")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { width: "120px" } },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass:
                                          "mt-1 orders-filter-dropdown",
                                        attrs: {
                                          variant: "outline-secondary",
                                          text: _vm.typesFilterLabel,
                                          block: "",
                                        },
                                      },
                                      _vm._l(
                                        _vm.orderTypesOptions,
                                        function (option, key) {
                                          return _c(
                                            "b-dropdown-item-button",
                                            {
                                              key: key,
                                              attrs: {
                                                active:
                                                  _vm.filters.types.indexOf(
                                                    option.value
                                                  ) >= 0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleFilterValue(
                                                    "types",
                                                    option.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              option.value !== "" &&
                                              _vm.filters.types.indexOf(
                                                option.value
                                              ) >= 0
                                                ? _c("b-icon-check")
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(option.text) +
                                                  "\n                  "
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c("div", { staticClass: "mt-1 mr-2" }, [
                                _c("div", [_vm._v("Status")]),
                                _vm._v(" "),
                                _c(
                                  "div",
                                  { staticStyle: { width: "150px" } },
                                  [
                                    _c(
                                      "b-dropdown",
                                      {
                                        staticClass:
                                          "mt-1 orders-filter-dropdown",
                                        attrs: {
                                          variant: "outline-secondary",
                                          text: _vm.statusesFilterLabel,
                                          block: "",
                                        },
                                      },
                                      _vm._l(
                                        _vm.orderStatusesOptions,
                                        function (option, key) {
                                          return _c(
                                            "b-dropdown-item-button",
                                            {
                                              key: key,
                                              attrs: {
                                                active:
                                                  _vm.filters.statuses.indexOf(
                                                    option.value
                                                  ) >= 0,
                                              },
                                              on: {
                                                click: function ($event) {
                                                  return _vm.toggleFilterValue(
                                                    "statuses",
                                                    option.value
                                                  )
                                                },
                                              },
                                            },
                                            [
                                              option.value !== "" &&
                                              _vm.filters.statuses.indexOf(
                                                option.value
                                              ) >= 0
                                                ? _c("b-icon-check")
                                                : _vm._e(),
                                              _vm._v(
                                                "\n                    " +
                                                  _vm._s(option.text) +
                                                  "\n                  "
                                              ),
                                            ],
                                            1
                                          )
                                        }
                                      ),
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1 mr-2" },
                                [
                                  _c("div", [_vm._v("Start Date")]),
                                  _vm._v(" "),
                                  _c("b-form-datepicker", {
                                    staticClass: "mt-1",
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      "date-format-options": {
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                      },
                                      locale: "en-US",
                                      "label-no-date-selected": "Choose date",
                                      "today-button": "",
                                      "reset-button": "",
                                      "close-button": "",
                                      "label-today-button": "Today",
                                      "label-reset-button": "Clear",
                                      max: _vm.max_date,
                                    },
                                    on: {
                                      input: (date) =>
                                        _vm.dateFilterChanged("start", date),
                                    },
                                    model: {
                                      value: _vm.filters.date_start,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "date_start", $$v)
                                      },
                                      expression: "filters.date_start",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1 mr-2" },
                                [
                                  _c("div", [_vm._v("End Date")]),
                                  _vm._v(" "),
                                  _c("b-form-datepicker", {
                                    staticClass: "mt-1",
                                    staticStyle: { width: "140px" },
                                    attrs: {
                                      "date-format-options": {
                                        year: "numeric",
                                        month: "numeric",
                                        day: "numeric",
                                      },
                                      locale: "en-US",
                                      "label-no-date-selected": "Choose date",
                                      "today-button": "",
                                      "reset-button": "",
                                      "close-button": "",
                                      "label-today-button": "Today",
                                      "label-reset-button": "Clear",
                                      max: _vm.max_date,
                                    },
                                    on: {
                                      input: (date) =>
                                        _vm.dateFilterChanged("end", date),
                                    },
                                    model: {
                                      value: _vm.filters.date_end,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.filters, "date_end", $$v)
                                      },
                                      expression: "filters.date_end",
                                    },
                                  }),
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "mt-1" },
                                [
                                  _c("div", [_vm._v("Show")]),
                                  _vm._v(" "),
                                  _c("b-form-select", {
                                    staticClass:
                                      "w-auto mt-1 orders-filter-select",
                                    attrs: {
                                      options: _vm.per_page_select_options,
                                    },
                                    on: { change: _vm.perPageFilterChanged },
                                    model: {
                                      value: _vm.per_page,
                                      callback: function ($$v) {
                                        _vm.per_page = $$v
                                      },
                                      expression: "per_page",
                                    },
                                  }),
                                ],
                                1
                              ),
                            ]
                          ),
                        ]
                      },
                      proxy: true,
                    },
                    {
                      key: "footer",
                      fn: function () {
                        return [
                          _vm.total_in_pages > 0
                            ? _c("b-pagination", {
                                staticClass: "admin-pagination mb-0",
                                attrs: {
                                  "total-rows": _vm.total_in_pages,
                                  "per-page": _vm.per_page,
                                  align: "center",
                                },
                                on: { change: _vm.loadOrders },
                                model: {
                                  value: _vm.page,
                                  callback: function ($$v) {
                                    _vm.page = $$v
                                  },
                                  expression: "page",
                                },
                              })
                            : _vm._e(),
                        ]
                      },
                      proxy: true,
                    },
                  ]),
                },
                [_c("admin-orders-table", { attrs: { orders: _vm.orders } })],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }